/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RoleSelect_proposal$ref: FragmentReference;
declare export opaque type RoleSelect_proposal$fragmentType: RoleSelect_proposal$ref;
export type RoleSelect_proposal = {|
  +databaseId: string,
  +viewerCanLinkRole: boolean,
  +organization: {|
    +onRestrictedPlan: boolean,
    +isOnV5: boolean,
  |},
  +circle: ?{|
    +databaseId: string
  |},
  +availableRoles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +currentlyUpdating: ?boolean,
      +node: ?{|
        +databaseId: string,
        +localizedName: string,
        +isLinked: boolean,
      |},
    |}>
  |},
  +$refType: RoleSelect_proposal$ref,
|};
export type RoleSelect_proposal$data = RoleSelect_proposal;
export type RoleSelect_proposal$key = {
  +$data?: RoleSelect_proposal$data,
  +$fragmentRefs: RoleSelect_proposal$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleSelect_proposal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanLinkRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onRestrictedPlan",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOnV5",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Circle",
      "kind": "LinkedField",
      "name": "circle",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableRolesConnection",
      "kind": "LinkedField",
      "name": "availableRoles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableRolesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentlyUpdating",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "localizedName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isLinked",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '8d486898360cfa56ebb787bc9118e119';

module.exports = node;
